import { useQuery } from '@tanstack/react-query';
import { queryFn, QUERY_KEY } from './queryFn';
import { ArticleTheme } from './enum';
import type { QueryKey } from './types';
import { persistedQueryConfig } from '@/utilities/persistQueryClient/utilities';

export const ITEMS_PER_PAGE = 13;

export const useLatestArticles = (queryKey: QueryKey) => {
  return useQuery({
    queryKey,
    queryFn,
    ...persistedQueryConfig,
  });
};

export const getLatestArticlesQueryKey = ({
  offset = 0,
  limit = ITEMS_PER_PAGE,
}: {
  offset?: number;
  limit?: number;
} = {}): QueryKey => {
  return [...QUERY_KEY, offset, limit, ArticleTheme.MARKET_WRAP_UP];
};

export type Articles = NonNullable<
  ReturnType<typeof useLatestArticles>['data']
>['articles'];
